import { GoHighLevelIcon } from '@mm/icons';
import { useSuppressionListsCRUDActions } from '@mm/state/actions/SuppressionListsCRUDActions';
import { selectGoHighLevelSuppressionList } from '@mm/state/modules/suppressionListsTableState/selectors';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import { Select, Switch } from 'antd';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import styles from './GoHighLevelIntegrations.module.css';
import { useConnectGoHighLevel } from './use-connect-gohighlevel';

type Props = {
  connectDisabled: boolean;
  tokenId: number;
};

export const GoHighLevelSuppressionSetup = ({
  connectDisabled,
  tokenId,
}: Props) => {
  const activeFbPageId = useSelector(activeFacebookPageIdSelector);

  const { update, create, retrieveAll } = useSuppressionListsCRUDActions();
  const suppressions = useSelector(selectGoHighLevelSuppressionList);
  const suppression = suppressions[0];
  const locations = useSelector(
    (state: StoreState) => state.goHighLevel.locations,
  );
  const updateSuppression = suppressionList => {
    const tokenKey = 'gohighlevel';
    if (suppression?.id) {
      update(activeFbPageId, suppressionList);
    } else {
      create(activeFbPageId, {
        ...suppressionList,
        enabled: suppressionList.enabled || false,
        sourceId: tokenId,
        sourceKind: tokenKey,
      });
    }
  };

  const { getGoHighLevelLocations } = useConnectGoHighLevel();

  useEffect(() => {
    if (suppressions.length === 0) {
      retrieveAll(activeFbPageId);
    }

    if (locations.length === 0) {
      getGoHighLevelLocations(activeFbPageId, tokenId, false);
    }
  }, []);

  return (
    <div
      className={classNames(styles.box, styles.suppressionBox, {
        [styles.boxDisabled]: connectDisabled,
      })}
    >
      <div className={classNames(styles.boxWithHelp)}>
        <div className={styles.boxContent}>
          <div className={classNames(styles.heading, styles.headingWithSwitch)}>
            Automatically suppress HighLevel contacts
            <Switch
              key={`switch-suppression-${
                suppression?.enabled ? 'enabled' : 'disabled'
              }`}
              defaultChecked={!!suppression?.enabled}
              checkedChildren="Yes"
              unCheckedChildren="No"
              className={styles.switch}
              onChange={ok =>
                updateSuppression({ ...suppression, enabled: ok })
              }
            />
          </div>

          <div className={styles.suppressionBlock}>
            <div className={styles.label}>
              <GoHighLevelIcon className={styles.gridIcon} /> Suppress leads
              from
            </div>
            <Select
              className={styles.locationsSelect}
              defaultValue={suppression?.locationId}
              placeholder="Choose"
              onChange={locationId =>
                updateSuppression({
                  ...suppression,
                  data: { ...(suppression?.data || {}), locationId },
                })
              }
              options={locations.map(loc => ({
                value: loc.id,
                label: loc.name,
              }))}
              popupClassName={styles.popup}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
